import React from "react";
import Header from "./Header";
import AgreementView from "../agreements/AgreementView";

export default function LayoutAgreementView() {
  return (
    <>
      <Header />
      <AgreementView />
    </>
  );
}
